// extracted by mini-css-extract-plugin
export default {"header":"Header_header__UMezK","head":"Header_head__-Mlhf","logo":"Header_logo__WW1D8","logout":"Header_logout__zefiJ"};